module.exports = __webpack_public_path__ + "static/img/bird8.d9f39be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird8.png
// module id = SzZQ
// module chunks = 1